<template>
  <div>
    <h2 align="center">
      Como funciona
    </h2>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},

  computed: {}
};
</script>

<style></style>
